import React,{useState,useEffect,useCallback}from'react';
import Layout from'../components/layout/Layout';

const INP=({value,onChange,type='text',placeholder=''}:any)=>(<input type={type} value={value} onChange={onChange} placeholder={placeholder} className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#015CA6]"/>);
const FLD=({label,children,required}:any)=>(<div><label className="block text-xs font-semibold text-gray-600 mb-1">{label}{required&&<span className="text-red-500 ml-0.5">*</span>}</label>{children}</div>);
const token=()=>localStorage.getItem('accessToken')||localStorage.getItem('token')||'';
const hdr=()=>({'Content-Type':'application/json','Authorization':`Bearer ${token()}`});
const BASE=process.env.REACT_APP_API_URL;

export default function LocationMasterPage(){
  const [loading,setLoading]=useState(true);
  const [tab,setTab]=useState<'states'|'cities'|'districts'|'pincodes'>('states');
  const [states,setStates]=useState<any[]>([]);
  const [cities,setCities]=useState<any[]>([]);
  const [districts,setDistricts]=useState<any[]>([]);
  const [pincodes,setPincodes]=useState<any[]>([]);
  const [search,setSearch]=useState('');
  const [msg,setMsg]=useState('');
  const [form,setForm]=useState<any>({});
  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),3000);};

  const load=useCallback(async()=>{
    setLoading(true);const [s,c,d,p]=await Promise.all([
      fetch(`${BASE}/settings/states`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/settings/cities`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/settings/districts`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/settings/pincodes`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
    ]);
    setStates(Array.isArray(s)?s:s?.data||[]);
    setCities(Array.isArray(c)?c:c?.data||[]);
    setDistricts(Array.isArray(d)?d:d?.data||[]);
    setPincodes(Array.isArray(p)?p:p?.data||[]);
    setLoading(false);
  },[]);

  useEffect(()=>{load();},[load]);

  const save=async()=>{
    const endpoints:any={states:'/settings/states',cities:'/settings/cities',districts:'/settings/districts',pincodes:'/settings/pincodes'};
    const r=await fetch(`${BASE}${endpoints[tab]}`,{method:'POST',headers:hdr(),body:JSON.stringify(form)});
    if(r.ok){notify('✅ Saved');setForm({});load();}else notify('❌ Failed');
  };

  const del=async(id:string)=>{
    const endpoints:any={states:'/settings/states',cities:'/settings/cities',districts:'/settings/districts',pincodes:'/settings/pincodes'};
    if(!window.confirm('Delete?'))return;
    await fetch(`${BASE}${endpoints[tab]}/${id}`,{method:'DELETE',headers:hdr()});
    notify('✅ Deleted');load();
  };

  const INDIA_STATES=['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Delhi','Jammu & Kashmir','Ladakh','Puducherry','Chandigarh','Dadra & Nagar Haveli','Daman & Diu','Lakshadweep','Andaman & Nicobar'];

  const seedStates=async()=>{
    let created=0;
    for(const s of INDIA_STATES){
      const r=await fetch(`${BASE}/settings/states`,{method:'POST',headers:hdr(),body:JSON.stringify({state_name:s,state_code:s.substring(0,2).toUpperCase(),country:'India'})});
      if(r.ok)created++;
    }
    notify(`✅ Created ${created} states`);load();
  };

  const all={states,cities,districts,pincodes};
  const current:any[]=all[tab]||[];
  const filtered=current.filter((i:any)=>!search||JSON.stringify(i).toLowerCase().includes(search.toLowerCase()));

  return(
    <Layout title="Location Master" actions={
      <div className="flex gap-2">
        {tab==='states'&&states.length===0&&<button onClick={seedStates} className="px-4 py-1.5 rounded-lg text-sm font-semibold text-white" style={{background:'#039089'}}>🇮🇳 Seed All India States</button>}
      </div>
    }>
      <div className="p-4">
        {msg&&<div className={`mb-4 p-3 rounded-xl text-sm font-medium border ${msg.startsWith('✅')?'bg-green-50 border-green-200 text-green-700':'bg-red-50 border-red-200 text-red-700'}`}>{msg}</div>}

        <div className="flex gap-1 mb-5 bg-gray-100 p-1 rounded-xl w-fit">
          {[['states','🗺️ States'],['districts','🏙️ Districts'],['cities','🌆 Cities'],['pincodes','📮 PIN Codes']].map(([t,l])=>(
            <button key={t} onClick={()=>{setTab(t as any);setSearch('');setForm({});}} className={`px-5 py-2 rounded-lg text-sm font-medium transition-all ${tab===t?'bg-white text-[#02357A] shadow font-semibold':'text-gray-600 hover:text-gray-800'}`}>{l}</button>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-5">
          {/* Add Form */}
          <div className="bg-white rounded-xl border shadow-sm p-5">
            <h3 className="font-bold text-gray-800 mb-4">Add {tab.slice(0,-1).charAt(0).toUpperCase()+tab.slice(1,-1)}</h3>
            <div className="space-y-3">
              {tab==='states'&&<><FLD label="State Name" required><INP value={form.state_name||''} onChange={(e:any)=>setForm((x:any)=>({...x,state_name:e.target.value}))} placeholder="Maharashtra"/></FLD><FLD label="State Code"><INP value={form.state_code||''} onChange={(e:any)=>setForm((x:any)=>({...x,state_code:e.target.value.toUpperCase()}))} placeholder="MH"/></FLD><FLD label="Country"><INP value={form.country||'India'} onChange={(e:any)=>setForm((x:any)=>({...x,country:e.target.value}))}/></FLD></>}
              {tab==='districts'&&<><FLD label="District Name" required><INP value={form.district_name||''} onChange={(e:any)=>setForm((x:any)=>({...x,district_name:e.target.value}))} placeholder="Pune"/></FLD><FLD label="State"><select value={form.state_id||''} onChange={(e:any)=>setForm((x:any)=>({...x,state_id:e.target.value}))} className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none"><option value="">Select State</option>{states.map((s:any)=><option key={s.id} value={s.id}>{s.state_name}</option>)}</select></FLD></>}
              {tab==='cities'&&<><FLD label="City Name" required><INP value={form.city_name||''} onChange={(e:any)=>setForm((x:any)=>({...x,city_name:e.target.value}))} placeholder="Pune"/></FLD><FLD label="District"><select value={form.district_id||''} onChange={(e:any)=>setForm((x:any)=>({...x,district_id:e.target.value}))} className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none"><option value="">Select District</option>{districts.map((d:any)=><option key={d.id} value={d.id}>{d.district_name}</option>)}</select></FLD><FLD label="State"><select value={form.state_id||''} onChange={(e:any)=>setForm((x:any)=>({...x,state_id:e.target.value}))} className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none"><option value="">Select State</option>{states.map((s:any)=><option key={s.id} value={s.id}>{s.state_name}</option>)}</select></FLD></>}
              {tab==='pincodes'&&<><FLD label="PIN Code" required><INP value={form.postal_code||''} onChange={(e:any)=>setForm((x:any)=>({...x,postal_code:e.target.value}))} placeholder="411001"/></FLD><FLD label="Post Office"><INP value={form.post_office||''} onChange={(e:any)=>setForm((x:any)=>({...x,post_office:e.target.value}))} placeholder="Pune City"/></FLD><FLD label="City"><select value={form.city_id||''} onChange={(e:any)=>setForm((x:any)=>({...x,city_id:e.target.value}))} className="w-full border rounded-lg px-3 py-2 text-sm bg-white focus:outline-none"><option value="">Select City</option>{cities.map((c:any)=><option key={c.id} value={c.id}>{c.city_name}</option>)}</select></FLD></>}
              <button onClick={save} className="w-full py-2.5 rounded-xl text-white font-semibold text-sm" style={{background:'#02357A'}}>+ Add</button>
            </div>
          </div>

          {/* List */}
          <div className="col-span-2">
            <div className="flex gap-3 mb-3">
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder={`Search ${tab}...`} className="flex-1 border rounded-xl px-4 py-2 text-sm focus:outline-none"/>
              <span className="text-sm text-gray-500 self-center">{filtered.length} records</span>
            </div>
            <div className="bg-white rounded-xl border overflow-hidden">
              <div className="max-h-[calc(100vh-280px)] overflow-y-auto divide-y">
                {filtered.length===0&&<p className="text-center py-10 text-gray-400 text-sm">{current.length===0?`No ${tab} added yet — use the form to add`:`No results for "${search}"`}</p>}
                {filtered.slice(0,200).map((item:any)=>(
                  <div key={item.id} className="flex items-center justify-between px-4 py-2.5 hover:bg-gray-50">
                    <div>
                      <p className="text-sm font-semibold text-gray-800">{item.state_name||item.district_name||item.city_name||item.postal_code||item.name||'—'}</p>
                      <p className="text-xs text-gray-400">{item.state_code||item.country||item.state_name||item.post_office||''}</p>
                    </div>
                    <button onClick={()=>del(item.id)} className="px-2 py-1 rounded text-xs bg-red-50 text-red-500 hover:bg-red-100">🗑️</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
